import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import DashboardTiles from "./components/DashboardTiles";
import LoginPage from "./components/LoginModal";
import {
  outer,
  storeHeader,
  storeHeaderTitle,
  leftColumn,
  outerStyle,
} from "./styles/DashboardStyles";
import BannerBar from "./components/BannerBar";
import CopyRightBanner from "components/CopyrightBanner";

const getCookie = (name: string): string | null => {
  try {
    const cookies = document.cookie?.split(";") ?? [];
    for (const cookie of cookies) {
      const [key, ...rest] = cookie.trim().split("=");
      if (key === name) {
        return decodeURIComponent(rest.join("="));
      }
    }
  } catch {
    // ignore cookie parsing errors and treat as missing
  }
  return null;
};

export const hasAuthTokens = (): boolean => {
  return Boolean(getCookie("authToken") && getCookie("refreshToken") && getCookie("userName") && getCookie("storeNumber"));
};

const Dashboard = () => {
  const [user] = useState<string>(sessionStorage.getItem("userName") || "");
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasAuthTokens() || !user) {
      navigate("/login", { replace: true });
    }
  }, [user, navigate]);

  return (
    <Box style={outerStyle}>
      <BannerBar user={user} />
      <Box sx={outer}>
        <Box sx={leftColumn}>
          <Box sx={storeHeader}>
            <Box sx={storeHeaderTitle}>Roti Store {user.replace("Store", "")}</Box>
          </Box>
          <DashboardTiles user={user} />
        </Box>
      </Box>
      <CopyRightBanner />
    </Box>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    </Router>
  );
};

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
